import React from 'react';
import BloxButton from 'sub_components/Common/BloxButton';
import { string, func, boolean } from 'prop-types';
const ConfirmationModal = ({ title, text, onAccept, onCancel, enabled }) => {
	return (
		<div className='confirmation-modal-wrapper' data-cy='confirmation-modal'>
			<div className='confirmation-modal'>
				<div className='title heading60'>{title}</div>
				<div className='text body10'>{text}</div>
				<div className='button-container'>
					<BloxButton
						title='CONFIRM'
						enabled={true}
						customClass={'blox-button-swipe'}
						onClick={
							enabled
								? () => {
										onAccept();
								  }
								: () => {}
						}
						id='confirm-button-swipe'
						cypressId='confirm-button'
					/>

					<BloxButton
						title='CANCEL'
						enabled={true}
						customClass='blox-button-swipe'
						onClick={() => {
							onCancel();
						}}
						id='cancel-button-swipe'
						cypressId='cancel-button'
					/>
				</div>
			</div>
		</div>
	);
};
ConfirmationModal.propTypes = {
	title: string,
	text: string,
	onAccept: func,
	onCancel: func,
	enabled: boolean,
};

ConfirmationModal.defaultProps = {
	title: 'Are you sure ?',
	text: 'Please confirm your action',
	onAccept: () => {},
	onCancel: () => {},
	enabled: true,
};

export default ConfirmationModal;
